import { useProductPriceInfo } from "@made-people/grease-product";
import { useTranslate } from "@made-people/grease-translations";

export const LowestPriceLast30Days = () => {
  const priceInfo = useProductPriceInfo();
  const translate = useTranslate();

  const lowestPrice30Days = priceInfo.previouslyDiscountedPrices?.find(
    (previouslyDiscountedPrice) => previouslyDiscountedPrice.periodDays === 30,
  );

  if (
    !lowestPrice30Days ||
    priceInfo.price.formatted === lowestPrice30Days.price.formatted
  ) {
    return null;
  }

  return (
    <p className="text-body-sm text-text-less-emphasis-1 col-span-3 mt-1">
      {translate("Price_History_Lowest_Price_In_Last_30_Days")}:{" "}
      {lowestPrice30Days.price.formatted}
    </p>
  );
};
